var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "__TEMP__SVG__",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.771,
    height: 14.771,
    viewBox: "0 0 14.771 14.771",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M7.386,13.848a6.463,6.463,0,1,1,6.463-6.463,6.463,6.463,0,0,1-6.463,6.463Zm0,.923A7.386,7.386,0,1,0,0,7.386,7.386,7.386,0,0,0,7.386,14.771Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M9.693,6a.462.462,0,0,1,.462.462v2.77h2.77a.462.462,0,0,1,0,.923h-2.77v2.77a.462.462,0,0,1-.923,0v-2.77H6.462a.462.462,0,0,1,0-.923h2.77V6.462A.462.462,0,0,1,9.693,6Z",
    transform: "translate(-2.307 -2.307)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.bf1c279f50ae5e98103c0a7092111651.svg";
export { ForwardRef as ReactComponent };